import { PresentedError } from './presented-error'

const STORAGE_KEY = 'arpio.dismissedPanelErrors'

// Mirrors localStorage so a claim doesn't parse JSON on every error.
let dismissed: Set<string> | null = null

function load(): Set<string> {
  if (dismissed) return dismissed
  try {
    dismissed = new Set(JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]'))
  } catch {
    dismissed = new Set()
  }
  return dismissed
}

/** Same host, title and detail is the same condition; the reference timestamp differs per attempt. */
function keyFor(hostId: string, presented: PresentedError): string {
  return `${hostId}|${presented.title}|${presented.detail ?? ''}`
}

export function isPanelErrorDismissed(hostId: string, presented: PresentedError): boolean {
  return load().has(keyFor(hostId, presented))
}

export function dismissPanelError(hostId: string, presented: PresentedError): void {
  const set = load().add(keyFor(hostId, presented))
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...set]))
  } catch {
    // localStorage can throw in private mode; the in-memory set still holds it this session.
  }
}

/** A new sign-in starts with every panel error visible again. */
export function clearDismissedPanelErrors(): void {
  dismissed = null
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore inaccessible localStorage
  }
}
